/**
 * RISKS-DOCUMENT.ROUTE
 * Document unique
 */
import NavApp, { risksDocumentNavItem } from "@/nav/nav.app"
import PageHeader from "@/components/page-header"
import { useAppSelector } from "@/core/root-reducer"
import documentStore from "@/entities/document/model/document.store"
import DocumentYearCard from "@/entities/document/ui/DocumentYearCard"
import { getDocumentYear, groupDocumentsByYear } from "@/entities/document/utils/document-year.utils"
import { isDocumentOutdated } from "@/entities/document/utils/document-outdated.utils"
import { useEffect, useState } from "react"
import Button from "@/components/button"
import { faUpload } from "@fortawesome/free-solid-svg-icons"
import DocumentUploadModal from "@/entities/document/ui/modal/DocumentUploadModal"
import { useSearchParams } from "react-router-dom"

export default function RisksDocumentRoute() {
  const [searchParams] = useSearchParams()
  const documents = useAppSelector(documentStore.selectors.list)
  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false)
  const establishmentId = useAppSelector((state) => state._session.establishmentId ?? state.establishment.active.id)
  const currentYear = new Date().getFullYear()
  const { groups, latestDuerp, latestPapripact } = groupDocumentsByYear(documents, currentYear)
  const duerpOutdated = isDocumentOutdated(documents)
  const autoOpenType = searchParams.get("type")
  //Only one year open at a time: the same document can be listed in several years
  const [openYear, setOpenYear] = useState<number | null>(currentYear)

  useEffect(() => {
    if (autoOpenType === "papripact" && latestPapripact) setOpenYear(getDocumentYear(latestPapripact))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoOpenType, latestPapripact?.id])

  return (
    <NavApp>
      <PageHeader
        title={risksDocumentNavItem.text}
        subtitle={"Générez et consultez les documents de prévention de votre établissement."}>
        <Button isFullWidth icon={faUpload} onClick={() => setIsUploadModalOpen(true)} isWithBorder>
          Uploader un document
        </Button>
      </PageHeader>

      {groups.map((group) => (
        <DocumentYearCard
          key={`${establishmentId}-${group.year}`}
          group={group}
          isPastYear={group.year < currentYear}
          latestDuerpId={latestDuerp?.id}
          latestPapripactId={latestPapripact?.id}
          isDuerpOutdated={duerpOutdated}
          isOpen={openYear === group.year}
          onToggle={() => setOpenYear(openYear === group.year ? null : group.year)}
          autoOpenType={
            autoOpenType === "duerp" && group.year === currentYear
              ? "duerp"
              : autoOpenType === "papripact" &&
                  latestPapripact &&
                  group.papripacts.some((document) => document.id === latestPapripact.id)
                ? "papripact"
                : undefined
          }
        />
      ))}

      {isUploadModalOpen && <DocumentUploadModal onClose={() => setIsUploadModalOpen(false)} />}
    </NavApp>
  )
}
